export default __webpack_public_path__ + "static/imgFifteen-b0be479a0bc6c0b289c0cb955c53ca03.jpg";